/* Skylit: check an email address before a save-for-later send, so a typo is
 * caught while the customer is still on the page. Used by every customiser's
 * "save for later" form (starmap-v2, myjs, moon-ui, name-landsat, locationmap).
 *
 *   SkylitEmailCheck(email).then(function (r) {
 *     if (!r.ok) { show(r.message); return; }   // fix it first
 *     send();
 *   });
 *
 * The admin (/api/check-email) checks the format, whether the domain exists,
 * and common slips ("gmial.com"). A "Did you mean ...?" is shown once; pressing
 * Send again with the same address goes ahead, as it may be right. If the check
 * itself fails (offline, slow), the address passes: a save is never blocked by
 * our own fault. */
(function () {
  var URL_BASE = 'https://admin.skylitstudio.co.uk/api/check-email/?email=';
  var warned = {};
  window.SkylitEmailCheck = function (email) {
    email = String(email || '').trim();
    if (!email) return Promise.resolve({ ok: false, message: 'Please enter your email address.' });
    if (/\s/.test(email)) return Promise.resolve({ ok: false, message: 'That email address has a space in it. Please check it and try again.' });
    var ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 3000) : 0;
    return fetch(URL_BASE + encodeURIComponent(email), ctl ? { signal: ctl.signal } : {})
      .then(function (r) { return r.ok ? r.json() : { ok: true }; })
      .catch(function () { return { ok: true }; })
      .then(function (r) {
        clearTimeout(timer);
        if (!r || r.ok === undefined) return { ok: true };
        if (!r.ok) return r;
        if (r.suggestion && !warned[email]) {
          warned[email] = true;
          return { ok: false, suggestion: r.suggestion, message: 'Did you mean ' + r.suggestion + '? If not, press send again.' };
        }
        return { ok: true };
      });
  };
})();
